export const NOTIFICATIONS_MODULE_NAME = "Notifications";
